<template>
  <b-container class="main-container" style="margin-top: 0">
    <h4 style="padding-bottom: 5px" v-if="adminRequest">
      {{
        adminRequest.workload.asurite.fullName +
        " - " +
        adminRequest.workload.timePeriod.description
      }}
      <b-button v-if="canEdit" v-b-modal.approve-modal variant="primary" class="ml-2 pull-right">Change Status</b-button>
      <b-button v-if="canEdit" v-b-modal.edit-modal variant="primary" class="ml-2 pull-right">Edit Request</b-button>
    </h4>

    <b-modal id="approve-modal" title="Update Status" @ok="submitAdminRequest">
      <p>Press 'OK' to mark this request with the selected status.</p>
      <p>
        You may also leave a note with this status change, which will be visible
        to the faculty member who made this request.
      </p>

      <b-form-group label="Status" label-class="control-label workload-course-label"
        :class="{ 'invalid-group': $v.form.statusId.$error }">
        <b-form-select :options="statuses" v-model="form.statusId" text-field="name" value-field="id" :class="{
          'form-control': true,
          'is-invalid': $v.form.statusId.$error,
        }"></b-form-select>
      </b-form-group>

      <b-form-group label="Notes" label-class="control-label workload-course-label">
        <b-form-textarea :rows="3" placeholder="(Optional) Enter notes..." v-model="form.notes"></b-form-textarea>
      </b-form-group>
    </b-modal>

    <b-modal id="edit-modal" title="Edit Request" v-model="openAdminRequestModal" size="lg"
      @ok.prevent="attemptAdminRequestSubmit = true" @cancel="openAdminRequestModal = false">
      <admin-request-form v-model="attemptAdminRequestSubmit" :adminRequest="adminRequest"
        :totalPercent="administrativePercent" v-if="adminRequest" v-on:complete="saveAdminRequest">
      </admin-request-form>

      <span v-if="$v.form.$error" class="span-feedback invalid-feedback">
        All fields must be filled out.
      </span>
    </b-modal>

    <b-row v-if="adminRequest">
      <b-col>
        <widget heading="Details">
          <b-row>
            <b-col>
              <dl>
                <dt>Current Status</dt>
                <dd>{{ adminRequest.currentStatus.statusName }}</dd>

                <dt>Total Percent</dt>
                <dd>{{ adminRequest.administrativePercent }}%</dd>

                <dt>Supervisor</dt>
                <dd>{{ adminRequest.supervisor.fullName }}</dd>

                <dt>Course Releases</dt>
                <dd>
                  <span v-if="adminRequest.numberOfCourses">{{ adminRequest.numberOfCourses }} courses</span>
                  <span v-else>None</span>
                </dd>

                <dt>Stipend</dt>
                <dd>{{ adminRequest.stipend | trueOrFalse }}</dd>

                <dt>Notes</dt>
                <dd>{{ adminRequest.notes }}</dd>
              </dl>
            </b-col>
          </b-row>
        </widget>
        <widget heading="Status History">
          <admin-request-history :statuses="adminRequest.statuses" />
        </widget>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Widget from "../../components/widget";
import AdminRequestHistory from "../../components/workloads/admin-request-history";
import AdminRequestForm from "../../components/workloads/admin-request-form";
import WorkloadFiles from "../../components/workloads/workload-files";
import roleChecks from "../../misc/role-checks";
import { required } from "vuelidate/lib/validators";
import adminRequestApi from "../../api/administrativeRequests.js";
import ToastrSettings from "../../settings/toastr-settings";
import toastr from "toastr";

export default {
  mixins: [roleChecks],
  //   name: "BuyoutDetails",
  data() {
    return {
      statuses: [],
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" },

      openAdminRequestModal: false,
      attemptAdminRequestSubmit: false,
      adminRequest: null,
      form: {
        id: 0,
        statusId: 0,
        notes: ""
      }
    };
  },

  props: {
    id: {
      required: true
    }
  },

  components: {
    widget: Widget,
    AdminRequestHistory,
    WorkloadFiles,
    AdminRequestForm
  },

  validations: {
    form: {
      statusId: { required },
      notes: { required }
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      files: state => state.workloads.files
    }),

    administrativePercent: function () {
      return this.adminRequest
        ? _.filter(this.adminRequest.workload.workloadTypes, type => {
          return type.workloadTypeDefinition.name === "Administration";
        })[0].value * 100
        : 0;
    },

    canEdit: function () {
      if (
        this.isAdminSupervisor &&
        this.adminRequest.supervisor.asuriteId == this.user.userId
      )
        return true;

      return false;
    }
  },

  methods: {
    ...mapActions("workloads", ["addWorkloadFiles"]),

    setForm: function (adminRequest) {
      // set values
      this.form = adminRequest;
    },

    load: function () {
      adminRequestApi
        .getById(this.id)
        .then(response => {
          this.adminRequest = response.data;
          this.form.statusId = this.adminRequest.adminRequestStatusDefinitionId;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    submitAdminRequest() {
      let updatedRequest = {
        administrativeRequestId: this.adminRequest.id,
        administrativeRequestStatusDefinitionId: this.form.statusId,
        notes: this.form.notes
      };

      adminRequestApi.postStatus(updatedRequest).then(() => {
        adminRequestApi.statusEmail(this.adminRequest.id);
        toastr.options = ToastrSettings;
        toastr.success("The request has been saved.", "Success");
        this.load();
      });
    },

    saveAdminRequest(request) {
      if (request) {
        this.attemptAdminRequestSubmit = false;
        adminRequestApi.updateRequest(request).then(() => {
          toastr.options = ToastrSettings;
          toastr.success("The request has been saved.", "Success");
          this.load();
        });
        this.openAdminRequestModal = false;
      }
    }
  },

  created() {
    adminRequestApi
      .getById(this.id)
      .then(response => {
        this.adminRequest = response.data;
        this.form.statusId = this.adminRequest.adminRequestStatusDefinitionId;
      })
      .catch(function (error) {
        console.log(error);
      });

    adminRequestApi.getStatusDefinitions().then(response => {
      this.statuses = response.data;
    });
  }
};
</script>

<style scoped>
.main-container {
  max-width: 100%;
  margin-top: 10px;
}
</style>
